export const highlight = (isHighlighted?: boolean) => {
  return isHighlighted ? 'outline-accent-red outline outline-dashed outline-2' : '';
};
